// "gtwill"  : "vue-cli-service serve --port 9100 --master:gtwill",
// "vietnam" : "vue-cli-service serve --port 9600 --master:vietnam",
// "dongwon" : "vue-cli-service serve --port 9700 --master:dongwon",
// "homeplus": "vue-cli-service serve --port 9800 --master:homeplus",
// "kbet"    : "vue-cli-service serve --port 9900 --master:kbet",
// "test"    : "vue-cli-service serve --port 19100 --master:test",

// let masterCode = "gtwill";
// console.log(`process.env.NODE_ENV: `, process.env);
// console.log(`masterCode: `, masterCode);
// console.log(`process.env.NODE_ENV: `, process.env.NODE_ENV);

console.log(`NODE_ENV : ${process.env.NODE_ENV}`);
console.log(`appTitle : ${process.env.VUE_APP_TITLE}`);
console.log(`masterCode : ${process.env.VUE_APP_masterCode}`);
console.log(`apiPort : ${process.env.VUE_APP_apiPort}`);
console.log(`expressWorkers : ${process.env.VUE_APP_expressWorkers}`);
console.log(`backEndWssPort : ${process.env.VUE_APP_backEndWssPort}`);

//xems backend의 여러 Port에 대한 정보는 Frontend에서 지정하는 것은 좋은 방법이 아님
//현재 front를 배포한 Backend Server에 현재 구성정보를 질의하여 적용할 수 있도록 변경해야 함.
//window.location.hostname, window.location.port
//GET server/info/

//const config = subscribe[masterCode];

//window.location.hostname

const config = {};

if (
    process.env.NODE_ENV === "production" ||
    global.xe.isEmpty(process.env.VUE_APP_backEndHost) ||
    global.xe.isEmpty(process.env.VUE_APP_apiPort)
) {
    //backEndHost와 apiPort가 정의되지 않았다면 현재 접속된 서버를 기준으로 설정함.
    console.log(
        ".env에 BackEnd의 host와 apiPort가 지정되지 않았으므로 현재 접속된 서버를 기준으로 Backend 접속정보를 설정함.",
    );

    config.protocol = window.location.protocol || "http";
    config.host = window.location.hostname || "localhost";

    // Added by badblock.2023.06.21
    // EMS 접속 포트가 지정되지 않고 호출되는 경우 WebServer 또는 ReverseProxy를 경유한 것으로 간주함.
    // 개발 환경(NODE_ENV !== 'production')에서는 프론트엔드 개발 서버 포트와 백엔드 API 포트를 구분해야 함
    if (process.env.NODE_ENV !== "production") {
        // 개발 환경: 프론트엔드 개발 서버(9999)를 프록시로 사용하므로 apiPort는 0으로 설정
        // API 호출은 Vue 개발 서버 프록시를 통해 백엔드로 전달됨
        config.apiPort = 0;
        config.backEndWssPort = 9010;
        config.wssForwardPath = null; // WebSocket은 직접 연결
        console.log(
            `Development mode: Frontend dev server on port ${window.location.port}, API calls via proxy (port 0 = same origin)`,
        );
    } else if (window.location.port > 0) {
        // 프로덕션 환경: 접속 포트를 기반으로 백엔드 포트 계산
        config.apiPort = window.location.port * 1;

        // 포트 관리 규칙 (100 단위 범위):
        // - 서버는 100 단위로 포트 범위 관리 (9000, 9100, 9200, 9300...)
        // - 각 서버는 베이스 포트 ~ +99 범위 내에서 포트 사용
        // - 베이스 포트 계산: 접속 포트를 100으로 나눈 몫 * 100
        // - WebSocket 포트: 베이스 포트 + 10
        // 예: 9001 접속 → 베이스 9000 → WebSocket 9010
        // 예: 9501 접속 → 베이스 9500 → WebSocket 9510
        // 예: 9000 접속 → 베이스 9000 → WebSocket 9010
        const basePort = Math.floor(config.apiPort / 100) * 100;
        config.backEndWssPort = basePort + 10;

        console.log(
            `포트 규칙 적용: 접속 포트 ${config.apiPort} → 베이스 포트 ${basePort} → WebSocket 포트 ${config.backEndWssPort}`,
        );
    } else {
        config.apiPort = 0;
        config.backEndWssPort = 0;
        config.wssForwardPath = "wssforward-front/";
    }

    // NOTI : 더 이상 사용하지 않음
    config.expressWorkers = process.env.VUE_APP_expressWorkers || 1;
} else {
    //  GS 테스트를 위한 임시 작업, 20250612
    config.protocol = process.env.VUE_APP_protocol || "http";
    config.host = process.env.VUE_APP_backEndHost || "localhost";
    config.apiPort = process.env.VUE_APP_apiPort * 1;
    config.expressWorkers = process.env.VUE_APP_expressWorkers || 1;
    config.backEndWssPort = process.env.VUE_APP_backEndWssPort * 1; //for typecasting
}

// window.location.protocol : 'http:' 으로 값을 반환하여
// 표준화하기 위해서는 ':'을 제거하고 url을 생성한다.
config.protocol = config.protocol.replace(":", "");

// HTTPS 전환: 백엔드가 HTTPS 전용이므로 프로덕션 환경에서만 protocol을 https로 강제
// 개발 환경(NODE_ENV !== 'production')에서는 프론트엔드 개발 서버가 HTTP로 실행되므로 HTTP 유지
// 포트 규칙: HTTP 서버 없음, HTTPS만 사용 (포트 변경 없음)
if (config.protocol === "http" && config.apiPort > 0 && process.env.NODE_ENV === "production") {
    console.warn(`Backend is HTTPS-only. Forcing protocol to https (포트는 변경하지 않음: ${config.apiPort}).`);
    config.protocol = "https";
    // 포트는 변경하지 않음 (HTTPS가 HTTP 포트와 동일한 포트 사용)
} else if (process.env.NODE_ENV !== "production" && config.protocol === "http") {
    // 개발 환경에서는 HTTP 유지 (프론트엔드 개발 서버가 HTTP로 실행됨)
    console.log(`Development mode: Using HTTP protocol (포트: ${config.apiPort}).`);
}

/*
if (config == null || config == undefined) {
  console.error(`Config is abnormal. Check your master code.`);
}
*/
if (config.apiPort == 0) {
    // 프록시 경유 또는 프로덕션 환경 (포트 정보 없음)
    if (process.env.NODE_ENV !== "production" && window.location.port) {
        // 개발 환경: 프론트엔드 개발 서버를 프록시로 사용
        config.apiUrl = `${config.protocol}://${config.host}:${window.location.port}`;
        // 개발 환경에서 WebSocket도 프론트엔드 개발 서버 프록시를 통해 연결 (인증서 오류 우회)
        config.wssUrl = `ws://${config.host}:${window.location.port}/ws`;
        console.log(`Development mode: Using frontend dev server as proxy`);
        console.log(`  API URL: ${config.apiUrl}`);
        console.log(
            `  WebSocket URL: ${config.wssUrl} (프록시를 통해 백엔드 ${config.host}:${config.backEndWssPort}로 연결)`,
        );
    } else {
        // 프로덕션 환경: 프록시 경유
        console.warn(`Proxy를 경유할 경우 WebSocket Forwarding URL(${config.wssForwardPath})을 반드시 설정해야 함.`);
        config.apiUrl = `${config.protocol}://${config.host}`;
        // 백엔드가 HTTPS 전용이므로 항상 wss:// 사용
        if (config.wssForwardPath) {
            config.wssUrl = `wss://${config.host}/${config.wssForwardPath}`;
        } else {
            config.wssUrl = `wss://${config.host}:${config.backEndWssPort}`;
        }
    }
} else {
    config.apiUrl = `${config.protocol}://${config.host}:${config.apiPort}`;
    // 백엔드가 HTTPS 전용이므로 항상 wss:// 사용
    config.wssUrl = `wss://${config.host}:${config.backEndWssPort}`;
}

export default {
    backend: {
        host: config.host,
        protocol: config.protocol,
        apiPort: config.apiPort,
        expressWorkers: config.expressWorkers,
        apiUrl: config.apiUrl,
        wssUrl: config.wssUrl,
    },
    // TODO: 에너지원 설정값 서버설정으로?
    resourcesAvailable: [
        { type: "elec", name: "전기" },
        { type: "gas", name: "가스" },
        { type: "heat", name: "난방" },
        { type: "water", name: "수도" },
    ],
};
